export const supportedLanguages = ['en'];

const languageKey = 'change-language';
const languagePreferenceVersionKey = 'change-language-version';
const languagePreferenceVersion = 'english-only-v2';

export function normalizeLanguage(value) {
  return value === 'en' ? 'en' : '';
}

export function getStoredLanguage() {
  return 'en';
}

export function persistLanguage() {
  const value = 'en';

  localStorage.setItem(languageKey, value);
  localStorage.setItem('lang', value);
  localStorage.setItem('language', value);
  localStorage.setItem(languagePreferenceVersionKey, languagePreferenceVersion);
  sessionStorage.setItem(languageKey, value);
  document.cookie = `${languageKey}=${encodeURIComponent(value)}; path=/; max-age=31536000; SameSite=Lax`;
  document.documentElement.setAttribute('lang', value);

  return value;
}
